import React from 'react';
import './Hero.css';

/**
 * Hero component
 * @param {string}  image    - background image src
 * @param {string}  eyebrow  - small label above title
 * @param {string}  title    - large heading
 * @param {boolean} minimal  - compact variant with no text overlay
 */
function Hero({ image, eyebrow, title, minimal = false }) {
  return (
    <div className={`hero${minimal ? ' hero--minimal' : ''}`}>
      <img src={image} alt="" className="hero-image" aria-hidden="true" />
      {!minimal && (eyebrow || title) && (
        <div className="hero-content">
          {eyebrow && <p className="hero-eyebrow">{eyebrow}</p>}
          {title && <h1 className="hero-title">{title}</h1>}
        </div>
      )}
    </div>
  );
}

export default Hero;